// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4":"9a53e88f","453":"9dce386d","468":"285086c8","677":"c5c7bdd3","762":"22e78a74"}[chunkId] + ".chunk.css";
};